export const updatePowerBiUrl = `
  mutation UpdatePowerBiUrl($url: String!) {
    updatePowerBiUrl(url: $url) {
      success
      message
      url
    }
  }
`;
